import styled from 'styled-components';
import { hexToRgba } from 'src/utils';

export const StyledWrapper = styled.div`
  padding: 0px;
  margin-top: 66px;
  border-radius: 6px;

  table {
    padding-left: 16px;
    padding-right: 16px;
  }
  & .MuiTableHead-root {
    & .MuiTableRow-root {
      & .MuiTableCell-root {
        background-color: ${(props) => props.theme.colors.appBackground};
        padding: 4px 8px;
        &:first-child {
          width: 40px;
        }
      }
    }
  }

  & .MuiTableBody-root {
    border-bottom: none;
    & .MuiTableRow-root {
      & .MuiTableCell-root {
        background-color: ${(props) => props.theme.colors.appBackground};
      }

      &:first-child {
        & .MuiTableCell-root {
          &:first-child {
            border-top-left-radius: 6px;
          }

          &:last-child {
            border-top-right-radius: 6px;
          }
        }
      }
      &:last-child {
        & .MuiTableCell-root {
          border-bottom: none;

          &:first-child {
            border-bottom-left-radius: 6px;
          }

          &:last-child {
            border-bottom-right-radius: 6px;
          }
        }
      }

      &:hover {
        & .MuiTableCell-root {
          background-color: ${(props) =>
            props.theme.isDarkTheme
              ? hexToRgba(props.theme.colors.grey3, 0.3)
              : hexToRgba(props.theme.colors.grey3, 0.4)};
        }
        cursor: pointer;
      }
    }
  }
`;
